import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, ArrowLeft } from "lucide-react";

const PasswordResetEmailSent = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-background via-secondary/20 to-accent/10">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md space-y-4">
          {/* Branding Section */}
          <div className="text-center space-y-3">
            <img
              src="https://www.terre-adelice.eu/wp-content/uploads/2025/10/logo-v-b.3-t.png"
              alt="Terre adélice"
              className="h-24 mx-auto object-contain"
            />
            <h1 className="text-4xl font-bold bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent animate-fade-in">
              Fidélice
            </h1>
          </div>

          {/* Success Card */}
          <Card className="w-full shadow-[var(--shadow-medium)]">
            <CardHeader className="space-y-0.5 pb-4 text-center">
              <div className="mx-auto mb-4 w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
                <Mail className="h-8 w-8 text-primary" />
              </div>
              <CardTitle className="text-xl font-bold">
                Email envoyé !
              </CardTitle>
              <CardDescription className="text-sm">
                Vérifiez votre boîte mail
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4 pt-3">
              <div className="space-y-2 text-sm text-muted-foreground">
                <p>
                  Nous vous avons envoyé un email contenant un lien pour réinitialiser votre mot de passe.
                </p>
                <p>
                  Si vous ne recevez pas l'email dans quelques minutes, pensez à vérifier votre dossier spam.
                </p>
              </div>

              <div className="pt-2">
                <Button
                  variant="outline"
                  className="w-full h-11 text-base font-semibold"
                  onClick={() => navigate("/auth")}
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Retour à la connexion
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetEmailSent;
